export const incidentIntelligenceRoutes = (root: string) => ({
  root,
  tickets: () => `${root}/tickets/:ticketId/artifacts/:ticketActivityId`,
});
